import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { EMAIL } from 'src/logic/constants/links';
import ContactForm from './ContactForm';
import { social_media } from './ContactUsPopup';
import StatusPopup from './StatusPopup';

const ContactSection = () => {
  const [status, setStatus] = React.useState<'idle' | 'success' | 'error'>('idle');

  return (
    <>
      <StatusPopup
        isOpen={status === 'success'}
        onClose={() => setStatus('idle')}
        color='success'
        Icon={CheckCircleOutlineIcon}
        description='Your message was successfully sent'
      />
      <StatusPopup
        isOpen={status === 'error'}
        onClose={() => setStatus('idle')}
        color='error'
        Icon={CancelOutlinedIcon}
        description='Something went wrong. Try again later'
      />
      <Box py={8}>
        <div className='page__content'>
          <Typography
            textAlign={'center'}
            fontSize={{ xs: 26, lg: 44 }}
            fontWeight={600}
            color='#070A0D'
            lineHeight={1}
            component='h2'
          >
            Got a question for us?
            <br />
            <span style={{ color: '#005FCC' }}>Get in touch</span>
          </Typography>

          <Typography
            color='#3C434A'
            lineHeight={1.5}
            fontSize={{ xs: 12, lg: 16 }}
            fontWeight={400}
            textAlign={'center'}
            my={2}
          >
            Use the form below to tell us a bit about yourself, and we will get back to you soon.
          </Typography>

          <Box
            mt={6}
            sx={{
              boxShadow: '0px 0px 40px 0px #0017721A',
              borderRadius: '20px',
              maxWidth: '800px',
              marginInline: 'auto',
            }}
          >
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              flexWrap={'wrap'}
              alignItems={'center'}
              sx={{ gap: { xs: 1, lg: 2 } }}
              px={3}
              py={3}
            >
              <Box display={'flex'} alignItems={'center'} gap={1}>
                <EmailOutlinedIcon sx={{ fontSize: { xs: 20, lg: 26 } }} />
                <Typography color='#000' fontWeight={600} fontSize={{ xs: 13, lg: 18 }} lineHeight={1}>
                  <a href={`mailto:${EMAIL}`} style={{ all: 'unset', cursor: 'pointer' }}>
                    {EMAIL}
                  </a>
                </Typography>
              </Box>
              <Box display={'flex'} alignItems={'center'} sx={{ gap: { xs: 1, lg: 2 } }}>
                {social_media.map(item => (
                  <a
                    key={item.link}
                    href={item.link}
                    target='_blank'
                    rel='noreferrer noopener'
                    style={{ display: 'flex', color: '#005FCC' }}
                  >
                    <item.icon sx={{ fontSize: { xs: 20, lg: 26 } }} />
                  </a>
                ))}
              </Box>
            </Box>
            <ContactForm onSuccess={() => setStatus('success')} onError={() => setStatus('error')} />
          </Box>
        </div>
      </Box>
    </>
  );
};

export default ContactSection;
